import { nanoid } from 'nanoid';

export function getStringId(length = 10): string {
  return nanoid(length);
}
